import {Component} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Job} from "../../../Interfaces/job.interface";
import {RestResponse} from "../../../Interfaces/RestResponse.interface";
import RestHelper from "../../../Helper/RestHelper";
import {ActivatedRoute, Router} from "@angular/router";
import Utils from "../../../Helper/Utils";
import {
  faBriefcase,
  faCalendarDays,
  faIndustry,
  faLocationDot,
  faMoneyCheckDollar
} from "@fortawesome/free-solid-svg-icons";
import {LoaderService} from "../../../services/loader/loader.service";
import ValidatorHelper from "../../../Helper/ValidatorHelper";

@Component({
  selector: 'app-job',
  templateUrl: './job.component.html',
  styleUrl: './job.component.css'
})
export class JobComponent {

  mapmarker = faLocationDot
  calendar = faCalendarDays
  industry = faIndustry
  salary = faMoneyCheckDollar
  publishingdate = faCalendarDays
  briefcase = faBriefcase

  protected readonly Utils = Utils;

  public job: Job | undefined
  public apierror: boolean = false

  constructor(private httpClient: HttpClient, private route: ActivatedRoute, private loader: LoaderService, private router: Router) {
    this.loader.showLoader()
    this.route.params.subscribe(params => {

      const uuid: string = params['uuid']

      if (!ValidatorHelper.isValidUUIDv4(uuid)) {
        this.loader.hideLoader()
        this.router.navigateByUrl('404', {skipLocationChange: true}).then(r => r ? console.error("Fehler beim umleiten auf NotFound Page") : "");
      } else {

        this.httpClient.get<RestResponse<Job>>(RestHelper.API_BASE_URL + "job/getJob?uuid=" + uuid, RestHelper.requestOptions).subscribe({
          next: (value) => {
            this.loader.hideLoader()
            this.job = value.data
          }, error: (err) => {
            const httpcode: number = err.status
            if (httpcode === 0) {
              this.apierror = true
            } else if (httpcode === 404) {
              this.router.navigateByUrl('404', {skipLocationChange: true}).then(r => r ? console.error("Fehler beim umleiten auf NotFound Page") : "");
            }
            this.loader.hideLoader()
          }
        })
      }
    });
  }
}
